import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

// Import images

const VideoSlider = () => {
  const [videoInfo, setVideoInfo] = useState([]);
  const [profileImg, setProfileImg] = useState([]);
  const [loading, setLoading] = useState(true);  // Handle loading state
  const [userId, setUserId] = useState(null);
  const { id } = useParams();
  const [ids, setIds] = useState(id);

  const fetchVideo = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getInstituteVideo?user_id=${ids}`);
      console.log("Institute video ", response.data);
      setVideoInfo(response.data);
      // setProfileImg(response.data.data.profileImg);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVideo();
  }, []); 
  return (
    <div className="institute-slider-container video-slider">
      {/* Show loader if data is still being fetched */}
      {loading ? (
        <p>Loading institutes...</p>
      ) : videoInfo.length > 0 ? (
        <OwlCarousel
          className="owl-theme"
          loop
          margin={15}
          nav
          autoplay
          autoplayTimeout={3000}
          responsive={{
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 },
          }}
        >
          {videoInfo.map((video, index) => (
            <div className="item course-item" key={video.id}>
              <div className="institute-card course-img">
                <video
                    className="boost_imgs course_video"
                    controls
                    style={{ width: "100%", maxHeight: "200px", objectFit: "cover" }}
                >
                    <source src={`${Image_Base_Url}${video.video_path}`} type="video/mp4" />
                </video>
              </div>
            </div>
          ))}
        </OwlCarousel>
      ) : (
        <p>No institutes available.</p>
      )}
    </div>
  );
};

export default VideoSlider;